// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColorSelect-module__main--bfH7F {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    gap: 8px;
}

.ColorSelect-module__colorView--jJkJ6.ColorSelect-module__big--vq8mY {
    --size: 32px;
}

.ColorSelect-module__colorView--jJkJ6.ColorSelect-module__large--rwOfD {
    --size: 48px;
}

.ColorSelect-module__colorView--jJkJ6 {
    --size: 24px;
    --color: gray;
    --border-width: 1px;
    --border-offset: 1px;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    cursor: pointer;
}

.ColorSelect-module__colorViewInner--TJRx7 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: var(--color);
    position: relative;
    overflow: hidden;
}

.ColorSelect-module__colorView--jJkJ6.ColorSelect-module__selected--vi2xT {
    border: var(--border-width) solid var(--color-general-black);
}

.ColorSelect-module__colorView--jJkJ6.ColorSelect-module__selected--vi2xT .ColorSelect-module__colorViewInner--TJRx7 {
    width: calc(var(--size) - var(--border-width) * 2 - var(--border-offset) * 2);
    height: calc(var(--size) - var(--border-width) * 2 - var(--border-offset) * 2);
}

.ColorSelect-module__colorPalette--JS9n5 {
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
    gap: 12px;
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0px 3px 32px 0px #857a6d33;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-flow: row;
    z-index: 1000;
    background-color: var(--color-general-white);
}

.ColorSelect-module__colorViewInnerItem--ub2Dn {
    --start-rotation: -45deg;
    --index: 0;
    --count: 2;
    --angle: calc(360deg / var(--count));
    --rotation: calc(var(--index) * var(--angle));
    --final-rotation: calc(var(--start-rotation) + var(--rotation));
    width: 100%;
    height: 100%;
    position: absolute;
}

.ColorSelect-module__colorViewInnerItem--ub2Dn.ColorSelect-module__colors2--AyCqC {
    transform: rotate(var(--final-rotation)) translateY(-50%);
}

.ColorSelect-module__colorViewInnerItem--ub2Dn.ColorSelect-module__colorsN--XTVeP {
    --index: 0;
    --count: 3;
    --angle: calc(360deg / var(--count));
    --rotation: calc(var(--index) * var(--angle));
    --skew: calc(var(--angle) - 90deg);
    --final-rotation: calc(var(--start-rotation) + var(--rotation));

    bottom: 50%;
    left: 50%;
    transform-origin: left bottom;
    transform: rotate(var(--final-rotation)) skewX(var(--skew));
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/ColorSelect/ColorSelect.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,6EAA6E;IAC7E,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,UAAU;IACV,oCAAoC;IACpC,6CAA6C;IAC7C,+DAA+D;IAC/D,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,UAAU;IACV,oCAAoC;IACpC,6CAA6C;IAC7C,kCAAkC;IAClC,+DAA+D;;IAE/D,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,2DAA2D;AAC/D","sourcesContent":[".main {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    gap: 8px;\n}\n\n.colorView.big {\n    --size: 32px;\n}\n\n.colorView.large {\n    --size: 48px;\n}\n\n.colorView {\n    --size: 24px;\n    --color: gray;\n    --border-width: 1px;\n    --border-offset: 1px;\n    width: var(--size);\n    height: var(--size);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    cursor: pointer;\n}\n\n.colorViewInner {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: var(--color);\n    position: relative;\n    overflow: hidden;\n}\n\n.colorView.selected {\n    border: var(--border-width) solid var(--color-general-black);\n}\n\n.colorView.selected .colorViewInner {\n    width: calc(var(--size) - var(--border-width) * 2 - var(--border-offset) * 2);\n    height: calc(var(--size) - var(--border-width) * 2 - var(--border-offset) * 2);\n}\n\n.colorPalette {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 8px);\n    gap: 12px;\n    border-radius: 12px;\n    padding: 12px 16px;\n    box-shadow: 0px 3px 32px 0px #857a6d33;\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-auto-flow: row;\n    z-index: 1000;\n    background-color: var(--color-general-white);\n}\n\n.colorViewInnerItem {\n    --start-rotation: -45deg;\n    --index: 0;\n    --count: 2;\n    --angle: calc(360deg / var(--count));\n    --rotation: calc(var(--index) * var(--angle));\n    --final-rotation: calc(var(--start-rotation) + var(--rotation));\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.colorViewInnerItem.colors2 {\n    transform: rotate(var(--final-rotation)) translateY(-50%);\n}\n\n.colorViewInnerItem.colorsN {\n    --index: 0;\n    --count: 3;\n    --angle: calc(360deg / var(--count));\n    --rotation: calc(var(--index) * var(--angle));\n    --skew: calc(var(--angle) - 90deg);\n    --final-rotation: calc(var(--start-rotation) + var(--rotation));\n\n    bottom: 50%;\n    left: 50%;\n    transform-origin: left bottom;\n    transform: rotate(var(--final-rotation)) skewX(var(--skew));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ColorSelect-module__main--bfH7F`,
	"colorView": `ColorSelect-module__colorView--jJkJ6`,
	"big": `ColorSelect-module__big--vq8mY`,
	"large": `ColorSelect-module__large--rwOfD`,
	"colorViewInner": `ColorSelect-module__colorViewInner--TJRx7`,
	"selected": `ColorSelect-module__selected--vi2xT`,
	"colorPalette": `ColorSelect-module__colorPalette--JS9n5`,
	"colorViewInnerItem": `ColorSelect-module__colorViewInnerItem--ub2Dn`,
	"colors2": `ColorSelect-module__colors2--AyCqC`,
	"colorsN": `ColorSelect-module__colorsN--XTVeP`
};
export default ___CSS_LOADER_EXPORT___;
